import { twJoin } from 'tailwind-merge';

import { Skeleton } from '@/_components';

import { Layout } from './layout';

function LoadingContent({ className }: { className?: string }) {
  return (
    <article className={twJoin('@container flex h-full flex-col justify-between gap-6', className)}>
      <section className="flex flex-row flex-wrap items-center justify-between gap-4">
        <Skeleton className="h-7 w-36 rounded-full" />
        <div className="flex flex-wrap items-center gap-2">
          <Skeleton className="h-7 w-24 max-w-1/4 rounded-full" />
          <Skeleton className="h-7 w-20 max-w-1/4 rounded-full" />
          <Skeleton className="h-7 w-60 max-w-1/2 rounded-xl" />
        </div>
      </section>

      <section className="grid w-full grid-cols-1 gap-3 @md:grid-cols-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800"
          >
            <div className="flex flex-wrap items-center gap-2">
              <Skeleton className="size-8 min-h-8 min-w-8 rounded-full" />
              <div className="flex flex-col gap-1">
                <Skeleton className="h-7 w-44 max-w-[70%] rounded-xl" />
                <Skeleton className="h-3 w-20 max-w-[50%] rounded-xl" />
              </div>
            </div>
            <Skeleton className="h-6 w-1/3 max-w-[75%] rounded-xl" />
          </div>
        ))}
      </section>

      <section className="mt-1">
        <Skeleton className="h-64 w-full rounded-xl" />
      </section>
    </article>
  );
}

export function RecurringRevenueVarianceLoading({
  className,
  layout = false,
}: {
  className?: string;
  layout?: boolean;
}) {
  return layout ? (
    <Layout>
      <LoadingContent className={className} />
    </Layout>
  ) : (
    <LoadingContent className={className} />
  );
}
